import { render, staticRenderFns } from "./WalletButton.vue?vue&type=template&id=a3ab4cd0&scoped=true&"
import script from "./WalletButton.vue?vue&type=script&lang=ts&"
export * from "./WalletButton.vue?vue&type=script&lang=ts&"
import style0 from "./WalletButton.vue?vue&type=style&index=0&id=a3ab4cd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ab4cd0",
  null
  
)

export default component.exports